import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./assets/style.scss";

/* js import */
import useScrollerClass from "./utils/useScrollerClass";

/* comp imports */
import OrientationCheck from "./components/OrientationCheck";

/* page imports */
import Landing from "./pages/Landing";
import InnerTents from "./pages/InnerTents";
import Videos from "./pages/Videos";
import Games from "./pages/Games";
import Recipes from "./pages/Recipes";
import AboutUs from "./pages/AboutUs";
import NotFound from "./pages/NotFound";
import Disclaimer from "./pages/Disclaimer";
import Footer from "./components/Footer";
// import SiteAudio from "./components/SiteAudio";
import Doctors from "./pages/Doctors";
import Chefs from "./pages/Chefs";
import ChefsBio from "./pages/ChefsBio";
import CarrotGameWrapper from "./games/CarrotGameWrapper";
import PicnicGameWrapper from "./games/PicnicGameWrapper";
import TowerGameWrapper from "./games/TowerGameWrapper";

function App() {
  useScrollerClass();
  return (
    <>
      <OrientationCheck />
      {/* <SiteAudio /> */}
      <Router>
        <Routes>
          <Route path="/">
            <Route index element={<Landing />} />
            <Route path="/inner-tents" element={<InnerTents />} />
            <Route path="/games" element={<Games />} />
            <Route path="/videos" element={<Videos />} />
            <Route path="/recipes" element={<Recipes />} />
            <Route path="/about-us" element={<AboutUs />} />
            <Route path="/doctors" element={<Doctors />} />
            <Route exact path="/chefs" element={<Chefs />} />
            <Route path="/chefs/:chefSlug" element={<ChefsBio />} />

            <Route path="/disclaimer" element={<Disclaimer />} />
            <Route path="/carrot-runner" element={<CarrotGameWrapper />} />
            <Route
              path="/picnic-food-builder"
              element={<PicnicGameWrapper />}
            />
            <Route path="/healthy-food-tower" element={<TowerGameWrapper />} />
            <Route path="/*" element={<NotFound />} />
          </Route>
        </Routes>
      </Router>
      <Footer />
    </>
  );
}

export default App;
